export enum SectionName {
	// V1 sections — to be removed in a follow-up cleanup once
	// `twg_microsite_exploration_v2` is rolled out and V1 deleted.
	Hero = 'hero',
	Overview = 'overview',
	ConnectorShowcase = 'connectorShowcase',
	Connectors = 'connectors',
	GraphExplorer = 'graphExplorer',
	CollaborationTop5 = 'collaborationTop5',
	OrgMetrics = 'orgMetrics',
	// Shared between V1 and V2.
	GettingStarted = 'gettingStarted',
	Footer = 'footer',
	// V2 sections — rendered behind `twg_microsite_exploration_v2`.
	Introduction = 'introduction',
	GraphPreview = 'graphPreview',
	ConnectedApps = 'connectedApps',
	Collaborators = 'collaborators',
	UserGraph = 'userGraph',
}

/** Auth state captured on every per-section analytics event. */
export type AuthState = 'loggedIn' | 'loggedOut';
